<div class="grid grid-cols-6 gap-2 mx-auto md:max-w-[300px]">
  <input
    *ngFor="let value of code; let i = index; trackBy: trackByIndex"
    maxlength="1"
    inputmode="numeric"
    name="{{ i }}"
    [(ngModel)]="code[i]"
    (input)="handleInput($event, i)"
    (keydown)="handleKeyDown($event, i)"
    (paste)="handlePaste($event)"
    #inputBox
    class="bg-white border border-gray-300 rounded-md w-10 h-10 text-center text-gray-700 focus:outline-none"
  />
</div>

<ng-container *ngIf="timeLeft > 0">
  <p class="mt-3 text-center">
    {{ display }}
  </p>
</ng-container>

<ng-container *ngIf="timeLeft === 0">
  <p
    class="mt-3 text-center w-full cursor-pointer text-primary text-base"
    (click)="onResend()"
  >
    Resend Code
  </p>
</ng-container>
